import { Helmet } from "react-helmet";
import React, { Suspense } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import Spinner from "../components/Spinner";
import LineIcon from 'react-lineicons';

function Notfound() {
  return (
    <Layout>
      <Helmet>
        <title>uh-oh! 404 not found</title>
        <meta
          name="description"
          content="Uh-oh! This resource may have been moved or deleted."
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-about-area mi-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="notfound">
                  <div className="notfound-inner text-center">
                    <h1>404 &#58;&#40;</h1>
                    <h3>Oops! Page not found.</h3>
                    <p>This resource may have been moved or deleted.</p>
                    <Link to="javascript:history.back()" className="mi-button">
                      <LineIcon name="arrow-left-circle"/> Go Back
                    </Link>
                    &nbsp;
                    <Link to="/" className="mi-button">
                      Go Home <LineIcon name="home"/>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Notfound;
